import {createTheme, ThemeOptions} from "@mui/material/styles";
import {grey, red} from "@mui/material/colors";

const createThemeOptions = (variant: string, colors: any): ThemeOptions => {
    return {
        breakpoints: {
            values: {
                xs: 0,
                sm: 640,
                md: 1080,
                lg: 1200,
                xl: 1536,
            },
        },
        typography: {
            fontSize: 12
        },
        components: {
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        padding: 6,
                    },
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: ({ownerState, theme}) => ({
                        ...(ownerState.variant === "outlined" && {
                            border:
                                variant === "light"
                                    ? "1px solid rgba(52, 58, 64, 0.5)"
                                    : "1px solid rgba(255, 255, 255, 0.5)",
                            borderRadius: 4,
                        }),
                    }),
                },
            },
            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                        backgroundColor:
                            variant === "dark" ? "#21232b" : "#2f333e",
                        color: "#fff",
                    },
                },
            },
            MuiBackdrop: {
                styleOverrides: {
                    root: {
                        //backgroundColor: mode === 'dark' ? '#21232b' : '#ebeef1',
                        color: variant === "dark" ? "#fff" : grey[900],
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        height: 50,
                        position: "relative",
                        backgroundColor:
                            variant === "dark" ? "#21232b" : "#cecfd2",
                        color: variant === "dark" ? "#fff" : grey[900],
                    },
                },
            },
            MuiToolbar: {
                styleOverrides: {
                    root: {
                        minHeight: "50px !important",
                        maxHeight: "50px !important",
                    },
                },
            },
            MuiDialogActions: {
                styleOverrides: {
                    root: {
                        paddingBottom: 0,
                        paddingLeft: 20,
                        paddingRight: 20,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: "unset",
                    },
                },
            },
            MuiDataGrid: {
                styleOverrides: {
                    root: {
                        "& .MuiDataGrid-cell:focus": {
                            outline: "none",
                        },
                        "& .MuiDataGrid-columnHeader:focus": {
                            outline: "none",
                        },
                        "& .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderDraggableContainer, & .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer": {
                            flexDirection: "row !important",
                        },
                    },
                    cell: {
                        "&.textAlignLeft": {
                            textAlign: "left !important",
                            justifyContent: "flex-start !important",
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                        },
                        "&.numberAlignRight": {
                            textAlign: "right !important",
                            justifyContent: "flex-end !important",
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                        },
                        "&.cellBorder": {
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                        },
                    },
                    header: {
                        "&.columnHeader": {
                            display: "flex",
                            justifyContent: "flex-start",
                            textAlign: "left",
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                        },
                    },
                },
            },
        },
        palette: {
            // @ts-ignore
            variant,
            // @ts-ignore
            mode: variant,
            primary: {
                main: "#e53935",
            },
            secondary: {
                main: variant === "dark" ? "#fff" : "#343a40",
            },
            error: {
                main: red[500],
            },
            ...(variant === "dark"
                ? {
                    background: {
                        default: "#2f333e",
                        paper: "#2f333e",
                        darker: "#21232b",
                        gridBlockColor: "#21232b",
                        viewHeader: "#2f333e",
                    },
                }
                : {
                    background: {
                        default: "#ebeef1",
                        paper: "#ebeef1",
                        darker: "#cecfd2",
                        gridBlockColor: "#f7f7f7",
                        viewHeader: "#ebeef1",
                    },
                }),
            text: {
                ...(variant === "dark"
                    ? {
                        primary: "#fff",
                        secondary: grey[500],
                    }
                    : {
                        primary: grey[900],
                        secondary: grey[800],
                    }),
            },
        },
    };
};

export const createAppTheme = (variant: string, colors: any) => {
    return createTheme(createThemeOptions(variant, colors));
};
